import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { printRef } from "../utils/functions";
import { displayDate } from "../reducers/TimeReducer";

function TableCreator(props) {
  const { data, cols } = props;
  const formatBool = (str) => {
    if (str === true) return "YES";
    if (str === false) return "NO";
    return str;
  };

  return (
    <table>
      <thead>
        <tr>
          {cols.map((c) => (
            <th key={`header-${c.headerName}`}>{c.headerName}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => (
          <tr key={`${item.id}-row`}>
            {cols.map((c) => (
              <td key={`${item.id}-${c.field}`}>
                {c.format === "date" && displayDate(item[c.field])}
                {c.format === "bool" && formatBool(item[c.field])}
                {c.format !== "date" && c.format !== "bool" && item[c.field]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function PrintsSearch3(props) {
  const { title, data, cols, kbdKey, print } = props;
  const ref = useRef();

  useEffect(() => {
    if (kbdKey === "Ctrl+KeyL" || print) {
      handlePrint();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kbdKey, print]);

  const handlePrint = () => {
    if (ref.current) {
      printRef(ref, title);
    }
  };

  const filterColumns = (columns) => columns.filter((col) => !col.hide);

  return (
    <Box
      sx={{
        display: "none",
        "@media print": {
          display: "block",
        },
      }}
    >
      <iframe
        id="print-iframe"
        title="iframe"
        style={{
          border: "none",
          overflow: "hidden",
          width: 1,
          height: 1,
        }}
      />
      <div ref={ref}>
        <h2>{title?.toUpperCase()}</h2>
        <TableCreator data={data} cols={filterColumns(cols)} />
        <h3>Total Records: {data?.length || 0}</h3>
      </div>
    </Box>
  );
}

export default PrintsSearch3;
